// schema.ts
import { z } from 'zod'

export const ACCEPTED_FILE_TYPES = ['application/pdf']

export const formSchema = z.object({
  // gender: z.object({
  //   id: z.string().min(1, 'Required'),
  //   name: z.string().min(1),
  // }),
  social_category_name: z.string().min(1, 'Required'),
  age: z.preprocess(
    (val) => Number(val),
    z
      .number({
        required_error: 'Age is required',
        invalid_type_error: 'Age must be a number',
      })
      .int('Age must be an integer')
      .positive('Age must be a positive number')
      .max(99, 'Age cannot exceed 2 digits')
  ),

  gender_name: z
    .string({ invalid_type_error: 'Required.' })
    .min(1, { message: 'Required.' }),
  gender: z.any(),
  role: z.any(),

  // social_category_name: z
  //   .string({ invalid_type_error: 'Required.' })
  //   .min(1, { message: 'Required.' }),
  social_category: z.any(),
  attended_kied_training: z.union([z.literal('0'), z.literal('1')]),
  training_names: z.string().min(1, 'Required'),
  training_period: z.string().min(1, 'Required'),
  enterprise_name: z.string().min(1, 'Required'),
  enterprise_address: z.string().min(1, 'Required'),
  business_type: z.string().min(1, 'Required'),
  business_activity: z.string().min(1, 'Required'),
  products_or_services: z.string().min(1, 'Required'),
  service_type: z.string().min(1, 'Required'),
  service_description: z.string().min(1, 'Required'),
  uploaded_document: z
    .instanceof(File)
    .optional()
    .nullable()
    .refine((file) => !file || ACCEPTED_FILE_TYPES.includes(file.type), {
      message: 'Only image files (.jpeg, .jpg, .png) are accepted',
    })
    .refine(
      (file) => !file || file.size <= 5_000_000, // 5MB limit
      {
        message: 'File size must be less than 5MB',
      }
    ),
})

export type FacilitationFormSchema = z.infer<typeof formSchema>
